import { Component, Input, Output, ViewEncapsulation,EventEmitter } from '@angular/core';
import { CTATypes } from '../../model/common.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { Account } from 'src/app/model/accounts.model';

@Component({
  selector: 'rch-account-selection',
  templateUrl: './account-selection.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class AccountSelectionComponent {
  @Input() accounts: any;
  @Output() onAccountSelection = new EventEmitter();
  CTATypes = CTATypes;
  selected: Account[] | undefined;
  
  constructor(private route: ActivatedRoute, private router: Router) {
  }

  continue() {
    this.onAccountSelection.emit(this.selected);
    console.log("Account-selection component - Continue button - Selected account: ", this.selected);
  }

  printAccountSelectionChange() {
    console.log("Account-selection component - printAccountSelectionChange() - Selected account: ", this.selected);
  }
}
